import React, { useContext } from 'react';
import VideoModal from '../modal/VideoModal';
import { ThemeContext } from 'styled-components';

export const PortfolioFilteringOnboardingVideoModal = ({ onClose }: { onClose: () => void }) => {
  const { Videos } = useContext(ThemeContext);

  if (!Videos.portfolioFilteringOnboarding) {
    return null;
  }

  return (
    <VideoModal onClose={onClose} trackHeartbeat={() => {}} title="How to use portfolio filtering" isInitiallyMuted>
      <source src={Videos.portfolioFilteringOnboarding} type="video/mp4" />
    </VideoModal>
  );
};
